<template>
    <Transition name="fade">
      <div v-if="show" class="fixed inset-0 flex items-center justify-center z-50 bg-black/50 backdrop-blur-sm">
        <div class="relative max-w-lg w-full mx-4">
          <button @click="$emit('close')" class="absolute top-4 right-4 text-white/60 hover:text-white">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <img 
            src="@/assets/pics/success.png" 
            alt="感謝訂閱"
            class="w-full h-auto shadow-2xl rounded-lg"
            @load="imageLoaded = true"
          >
        </div>
      </div>
    </Transition>
  </template>
  
  <script setup lang="ts">
  import { ref } from 'vue'
  
  defineProps<{
    show: boolean
  }>()
  
  defineEmits<{
    (e: 'close'): void
  }>()
  
  const imageLoaded = ref(false)
  </script>
  
  <style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
  </style>
  
  <style scoped>
  .backdrop {
    -webkit-backdrop-filter: blur(8px);
    backdrop-filter: blur(8px);
  }
  </style>